// Language Translations for the website
// Amharic text uses Unicode characters

export const translations = {
  english: {
    // Navigation
    home: "Home",
    about: "About",
    leadership: "Leadership",
    gallery: "Gallery",
    donate: "Donate",

    // Header/Footer
    church_name: "Saint Mary Parish Wellington",
    a_spiritual_home: "A Spiritual Home",

    // Greeting Section
    greeting_title:
      "Ethiopian Orthodox Tewahdo Church eastern Ausralia and New Zealand Dioces Tsirha Tsion St. Mary Parish Of Wellington",
    greeting_subtitle:
      "A spiritual home for the Ethiopian Orthodox community in Wellington. United in worship, faith, and the mission to build our permanent church.",

    // Services
    holy_qurbana: "Holy communion (Divine Liturgy)",
    holy_qurbana_desc:
      "Participate in the ancient Ethiopian Orthodox Tewahedo Divine Liturgy, the central act of worship connecting us to the Apostolic tradition.",
    sacraments: "Sacraments of the Church",
    sacraments_desc:
      "Receive the seven sacred mysteries as practiced in the Ethiopian Orthodox Tewahedo tradition.",
    spiritual_direction: "Spiritual Direction & Confession",
    spiritual_direction_desc:
      "Seek spiritual guidance and confession from our clergy to grow in faith and reconciliation with God.",
    fasting_prayer: "Fasting & Prayer Disciplines",
    fasting_prayer_desc:
      "Observe the Ethiopian Orthodox Tewahedo fasting calendar with its rich spiritual practices.",
    geez_language: "Ge'ez Language & Liturgy",
    geez_language_desc:
      "Experience our sacred liturgy in Ge'ez, the ancient ecclesiastical language of the Ethiopian Orthodox Church.",
    community: "Community & Cultural Heritage",
    community_desc:
      "Celebrate Ethiopian Orthodox traditions, feast days, and community gatherings that unite us in faith.",

    // Donations
    support_our_church: "Support Our Church",
    help_build_church:
      "Help us build our permanent church home and support our mission",
    donate_online: "Donate Online",
    bank_transfer: "Bank Transfer",
    contact_us: "Contact Us",
    donate_givealittle: "Support us on GiveALittle",
    bank_details: "Bank Details",
    account_number: "Account Number",
    reference: "Reference",
    contact_support:
      "For other donation methods or inquiries about supporting our mission",
    get_in_touch: "Get in Touch",
    thank_you_donation:
      "Thank you for your generosity and support in building our permanent church home.",

    // Location
    find_us: "Find Us",
    location: "Location",
    open_maps: "📍 Open in Google Maps",

    // Contact
    contact_us_heading: "Contact Us",
    contact_desc:
      "For inquiries, blessings, or to learn more about our community, please reach out.",
    email_label: "Email",
    phone_label: "Primary Contact",

    // Leadership
    leadership_contact: "Leadership & Contact",
    head_priest: "The Head Priest",
    spiritual_coordinator: "Spiritual Services Coordinator",

    // Footer
    quick_links: "Quick Links",
    footer_about_us: "About Us",
    footer_all_rights:
      "© {year} Saint Mary Ethiopian Orthodox Tewahedo Church. All rights reserved.",
    footer_made_with_love: "Made with ❤️ for our community",

    // Section Headers
    about_our_church: "About Our Church",
    worship_services: "Worship & Services",
    worship_services_desc:
      "Join us for our worship services and spiritual activities",
    church_building_project: "Church Building Project",
    church_calendar: "Church Calendar",
    calendar_desc:
      "Major Ethiopian Orthodox fasting days, feasts, and holy celebrations.",
    leadership_section: "Leadership & Contact",
    leadership_section_desc:
      "Meet our church leadership and get in touch with us",
    donations_header: "Support Our Church",
    projects_header: "Church Building Project",

    // Services & Activities
    weekly_liturgy: "Weekly Liturgy (Kidase)",
    weekly_liturgy_details:
      "Our main weekly worship service with Holy Communion",
    prayer_fellowship: "Prayer & Fellowship",
    prayer_fellowship_details:
      "Weekday prayer services and fellowship gatherings",
    sunday_school: "Sunday School for Children",
    sunday_school_details:
      "Religious education and spiritual formation for children",
    bible_study: "Bible Study & Spiritual Teaching",
    bible_study_details: "Deep dive into scripture and church teachings",
    community_support: "Community Support and Cultural Programs",
    community_support_details:
      "Community outreach and cultural preservation activities",

    // Service Card Day Labels
    service_day_weekly: "Weekly Liturgy",
    service_day_prayer: "Weekday Prayer",
    service_day_children: "Children",
    service_day_bible: "Bible Study",
    service_day_community: "Community",

    // Timeline labels
    weekly: "Weekly",
    sundays: "Sundays",
    saturdays: "Saturdays",
    as_announced: "As Announced",
    regularly: "Regularly",
    ongoing: "Ongoing",

    // Church Events
    timkat: "Timkat (Epiphany)",
    timkat_desc: "Celebration of the Baptism of Our Lord Jesus Christ",
    fasika: "Fasika (Easter)",
    fasika_desc: "Celebration of the Resurrection of Our Lord Jesus Christ",

    // Church Building
    church_building_desc:
      "Our parish has purchased land to build a permanent Ethiopian Orthodox church and community hall in Wellington. This project will provide a place of worship, cultural preservation, education, and gathering for generations to come. We are actively fundraising to complete the construction.",

    // About Our Church - Timeline Section Headers
    timeline_section_1_title: "Pre church",
    timeline_section_2_title: "Establishment of the church",
    timeline_section_3_title: "Future plan",

    // About Our Church - Full Descriptions
    about_church_intro: `
In the name of the Father, and of the Son, and of the Holy Spirit one God. Amen. Before Tsirha Tsion church of Wellington reached its current location, Orthodox believers living in New Zealand established an association in 2001, renting individual homes and various halls to preserve their Holy Orthodox faith and improve their spiritual lives, where they would learn from each other and pray together. In this community, without a church father, they would gather in the name of Our Lady, reading and studying the Gospel, recounting miracles and martyrdoms, and quenching their souls' thirst for the Word of God. Later, when there were baptisms and during certain festival, a priest with a tabot were brought from Auckland and Christ Church, and a mass service was started by a priest. While this was going on, in July 2016, the Tswa Association was registered as a charitable organization in New Zealand under the name Ethiopian Orthodox Tewahedo the Holy Mary Incorporated. This gave the association legal personality and organized fundraising, which made a great contribution to the establishment of the current church.

Due to the strong desire to have a permanent father, after 3 years of hard work and ups and downs, God's will be fulfilled on November 28, 2018, and Father Melake Tsion Komos Abba Tekle Selassie, who is currently serving, was able to come. After 17 years of association, in September of the same year, with the good will of His Holiness Abune Henok, then Archbishop of the Diocese of Eastern Australia and New Zealand, the association grew into a church, God willing, when the tabot of our Mother, the Blessed Virgin Mary, arrived. The establishment of the church and the arrival of the priest provided a permanent service to the faithful who had been longing for a priest who would sanctify, perform the sacraments, preach the gospel, and teach their children for many years. Since the time our Father came, he has been tireless and tireless in taking on the responsibility given to him by our Lord and Savior Jesus Christ, “Feed my lambs, take care of my sheep, feed my sheep” (John 21:15-17), by gathering believers, preaching the Word of God, performing the mysteries, organizing and teaching Sunday school students, and producing many deacons expanded his pastoral work.

Although the church where services are currently being held is rented, our church purchased a beautiful 5.2-hectare plot of land on September 27, 2023, and obtained permission to build a church building. We are currently raising funds to build a church, community hall, accommodation unit, holy water house and baptism unit at this location where believers can receive various services.
`,

    about_church_mission:
      "Our mission is to provide a permanent spiritual home for the Ethiopian Orthodox community, preserve the Apostolic faith and traditions, offer accessible spiritual guidance and pastoral care, foster a sense of community and cultural identity, and engage in meaningful outreach and service to those in need.",

    // Ethiopian Calendar & Holidays
    ethiopian_calendar: "Ethiopian Calendar",
    today: "Today",
    prev_month: "← Previous",
    next_month: "Next →",
    prev_month_disabled: "Cannot navigate to past months",
    next_month_disabled: "Cannot navigate more than 1 year forward",
    current_month_message:
      "You're at the current month. Cannot navigate to past months.",
    forward_limit_message:
      "You've reached the forward limit (1 year from today)",
    holiday: "Holiday",
    fast_day: "Fast Day",
    normal: "Normal",

    // Major Ethiopian Orthodox Holidays
    meskel: "Meskel (Finding of the True Cross)",
    meskel_date: "17 Meskerem (September 27)",
    meskel_gregorian: "September 27",
    meskel_desc:
      "Celebration of the discovery of the True Cross by Saint Helena",

    ganna: "Ganna (Christmas)",
    ganna_date: "29 Tahsas (January 7)",
    ganna_gregorian: "January 7",
    ganna_desc: "Birth of Our Lord Jesus Christ",

    timkat: "Timkat (Epiphany)",
    timkat_date: "11 Tir (January 19)",
    timkat_gregorian: "January 19",
    timkat_desc: "Baptism of Our Lord Jesus Christ",

    fasika: "Fasika (Easter)",
    fasika_date: "Variable Date",
    fasika_gregorian: "April/May (Variable)",
    fasika_desc: "Resurrection of Our Lord Jesus Christ",

    eriter: "Eriter (Passion Week)",
    eriter_date: "Before Fasika",
    eriter_gregorian: "Variable",
    eriter_desc: "Holy week leading to Easter",

    dimiter: "Dimiter (Archangel Michael & other Angels)",
    dimiter_date: "9 Miyazya (May 17)",
    dimiter_gregorian: "May 17",
    dimiter_desc: "Celebration of Archangel Michael",

    assumption: "Assumption of Mary",
    assumption_date: "21 Nehassie (August 28)",
    assumption_gregorian: "August 28",
    assumption_desc: "Assumption of the Blessed Virgin Mary",

    archangel: "Archangel Michael and Gabriel",
    archangel_date: "12 Sene (November 8)",
    archangel_gregorian: "November 8",
    archangel_desc: "Celebration of Archangels Michael and Gabriel",

    martyrs: "Commemoration of Martyrs",
    martyrs_date: "29 Hamle (July 8)",
    martyrs_gregorian: "July 8",
    martyrs_desc: "Remembrance of the martyrs of the faith",

    noel: "Noel",
    noel_date: "25 Tahsas (January 2 - Old Calendar)",
    noel_gregorian: "January 2",
    noel_desc: "Ethiopian Christmas celebration",

    epiphany: "Epiphany",
    epiphany_date: "11 Tir (January 19)",
    epiphany_gregorian: "January 19",
    epiphany_desc: "Manifestation of Jesus Christ",

    circumcision: "Circumcision of Jesus",
    circumcision_date: "13 Tahsas (January 1 - Old Calendar)",
    circumcision_gregorian: "January 1",
    circumcision_desc: "Circumcision of Our Lord Jesus Christ",

    nativity_mary: "Nativity of Mary",
    nativity_mary_date: "30 Elul (September 8)",
    nativity_mary_gregorian: "September 8",
    nativity_mary_desc: "Birth of the Virgin Mary",

    all_saints: "All Saints' Day",
    all_saints_date: "1 Hamle (July 20)",
    all_saints_gregorian: "July 20",
    all_saints_desc: "Celebration of all saints",

    trinity: "Trinity (Sllase)",
    trinity_date: "50 Days after Fasika (Pentecost)",
    trinity_gregorian: "Variable (May/June)",
    trinity_desc: "Holy Trinity and Ascension celebration",

    // Worship Services Details
    weekly_liturgy_title: "Weekly Liturgy (Kidase)",
    weekly_liturgy_time: "Sundays 9:00 AM",
    weekly_liturgy_location: "206 Coast Road, Wainuiomata",

    prayer_fellowship_title: "Prayer & Fellowship",
    prayer_fellowship_time: "Weekdays",
    prayer_fellowship_location: "Church",

    sunday_school_title: "Sunday School for Children",
    sunday_school_time: "every Saturday",
    sunday_school_location: "Education Room",

    bible_study_title: "Bible Study & Spiritual Teaching",
    bible_study_time: "As Announced",
    bible_study_location: "Church",

    community_support_title: "Community Support & Cultural Programs",
    community_support_time: "Ongoing",
    community_support_location: "Church & Community",

    // Calendar UI
    calendar_prev_label: "← Previous",
    calendar_next_label: "Next →",
    calendar_today_label: "Today",
    calendar_holiday_label: "Holiday",
    calendar_fast_label: "Fast Day",
    calendar_normal_label: "Normal",

    // Leadership Details
    head_priest_desc: "Abba Teklesilassie Bokan",
    spiritual_coordinator_desc: "Deacon Dawit Shafe",
    head_priest_email: "Email",
    head_priest_phone: "Phone",
    spiritual_coordinator_email: "Email",
    spiritual_coordinator_phone: "Phone",

    // Address Info
    street_address: "206 Coast Road, Wainuiomata",
    city_name: "Lower Hutt",
    postal_code: "5373",
    country_name: "New Zealand",

    // Bank Details
    bank_name: "ANZ Bank",
    account_name: "Ethiopian Orthodox Tewahido Church",
    reference_number: "Church Building Project",

    // Additional Navigation & Contact
    name_label: "Name",
    email: "Email",
    message: "Message",
    send: "Send",
    required_field: "Required",

    // General Labels
    date: "Date",
    time: "Time",
    read_more: "Read More",
    close: "Close",
    menu: "Menu",
    search: "Search",
  },

  amharic: {
    // Navigation
    home: "ቀዳሚ ገጽ",
    about: "ስለ ቤተ-ክርስቲያናችን",
    leadership: "አስተዳደር",
    gallery: "ጋለሪ",
    donate: "ይለግሱ",

    // Header/Footer
    church_name: "ዌሊንግተን ጽርሐ ጽዮን ​ቅድስት ማርያም ቤተ-ክርስቲያን- ኒውዚላንድ",
    a_spiritual_home: "መንፈሳዊ ቤት",

    // Greeting Section
    greeting_title:
      "የኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተ-ክርስቲያን በምሥራቅ አውስትራሊያ እና ኒውዚላንድ ሀገረ ስብክት የዌሊንግተን ጽርሐ ጽዮን ​ቅድስት ማርያም ቤተ-ክርስቲያን",
    greeting_subtitle:
      "በዌሊንግተን የምንገኝ የኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተክርስቲያን ማኅበረ ምእመናን እምነታችን ባህላችን አንድነታችን ጠብቀን ሥርዓተ አምልኮ የምንፈጽምባትን አንዲት ቅድስት ቤተ ክርስቲያን በመገንባት ላይ እንገኛለን።",

    // Services
    holy_qurbana: "ሥርዓተ ቅዳሴ",
    holy_qurbana_desc: "ቤተ-ክርስቲያናችን በየሳምንቱ እሁድ የቅዳሴ ሥርዓት ታከናውናልች። እርሶም ይሳተፉ።",
    sacraments: "ምሥጢራተ ቤተክርስቲያን",
    sacraments_desc:
      "በኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተክርስቲያን አስተምህሮ መሰረት የምስጢረ ቤተ-ክርስቲያን አገልግሎት እንሰጣልን። እርስዎም ይሳተፉ።",
    spiritual_direction: "መንፈሳዊ እገዛና ንስሐ",
    spiritual_direction_desc:
      "ቤተ-ክርስቲያናችን የመንፍሳዊ እገዛ እና የንስሐ አገልግሎት ስለምትሰጥ የአገልግሎቱ ተጠቃሚ ይሁኑ",
    fasting_prayer: "ጾም እና የጸሎት ሥርዓት",
    fasting_prayer_desc: "ስለ ጾምና ጸሎት የቤተ-ክርስቲያናችን አስተምህሮ ማወቅ ይፈልጋሉ?  ።",
    geez_language: "ግእዝ ቋንቋ እና ቅዳሴ",
    geez_language_desc:
      "የኢትዮጵያ ኦርቶዶክስ ተዋሕዶ ቤተ ክርስቲያን ጥንታዊ የቤተ ክርስቲያን ልሳን በሆነው በግእዝ ቅዳሴያችንን ተለማመዱ",
    community: "ሃይማኖታዊ ክብረ በዓላት",
    community_desc: "በቤተክርስቲያናችን ትውፊት መሰረት የሚከበሩ ዓመታዊ ክብረ በዓላትን አብረው ያክብሩ።",

    // Donations
    support_our_church: "ቤተክርስቲያናችንን ይርዱ",
    help_build_church: "ቋሚ የቤተክርስቲያናችንን ቤት እንድንገነባ እና ተልዕኮአችንን እንድናከናውን አግዙን",
    donate_online: "ኦንላይን ይለግሱ",
    bank_transfer: "በባንክ ያስተላልፉ",
    contact_us: "ያግኙን",
    donate_givealittle: "በ GiveALittle ይለግሱ",
    bank_details: "ባንክ",
    account_number: "ባንክ አካውንት",
    reference: "ዋቢ",
    contact_support: "ተጨማሪ እርዳታ ማድረግ ከፈለጉ ይጠይቁን",
    get_in_touch: "ያግኙን",
    thank_you_donation: "ስለ ልግስናችሁ እናመሰኛለን።",

    // Location
    find_us: "ያግኙን",
    location: "መገኛ",
    open_maps: "📍 በ Google Maps ያግኙ",

    // Contact
    contact_us_heading: "ያግኙን",
    contact_desc: "ለጥያቄዎ፣ ቡራኬ ከፈለጉ ወይም ስለ ቤተክርስቲያናችን የበለጠ ለማወቅ ክፈለጉ።",
    email_label: "ኢሜይል",
    phone_label: "ዋናው ግንኙነት",

    // Leadership
    leadership_contact: "አስተዳድር እና አድራሻ",
    head_priest: "አስተዳዳሪ",
    spiritual_coordinator: "የመንፈሳዊ አገልግሎት አስተባባሪ",

    // Footer
    quick_links: "ፈጣን ማስፈንጠሪያዎች",
    footer_about_us: "ስለ እኛ",
    footer_all_rights:
      "© {year}የኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተ-ክርስቲያን በምሥራቅ አውስትራሊያ እና ኒውዚላንድ ሀገረ ስብክት በዌሊንግተን ጽርሐ ጽዮን ​ቅድስት ማርያም ቤተ-ክርስቲያን",
    footer_made_with_love: "❤️ ለማህበረ ምእመናችን የተሰራ",

    // Section Headers
    about_our_church: "ስለ ቤተ-ክርስቲያናችን",
    worship_services: "ሥርዓተ አምልኮ እና አገልግሎቶቻችን",
    worship_services_desc: "ለአምልኮ ሥርዓት እና ለመንፈሳዊ አገልግሎት ይቀላቀሉን",
    church_building_project: "የቤተክርስቲያናችን ግንባታ ፕሮጀክት",
    church_calendar: "የቤተክርስቲያናችን ቀን መቁጠሪያ",
    calendar_desc: "የአጽዋማት ቀኖችን፣ በዓላትን እና ዓመታዊ ክብረ በዓላትን ይመልከቱ ።",
    leadership_section: "አስተዳደር",
    leadership_section_desc: "የቤተክርስቲያናችን አስተዳደር ያግኙ",
    donations_header: "ቤተክርስቲያናችንን ይርዱ",
    projects_header: "የቤተክርስቲያን ግንባታ ፕሮጀክት",

    // Services & Activities
    weekly_liturgy: "ሳምንታዊ ቅዳሴ",
    weekly_liturgy_details: "በየሳምንቱ እሁድ በሥርዓተ ቅዳሴ ላይ ይሳተፉ",
    prayer_fellowship: "ጸሎት እና ኅብረት",
    prayer_fellowship_details: "በየሳምነቱ ለጸሎት ህብረታችንን ይቀላልቀሉ ",
    sunday_school: "ሰንበት ትምህርት ቤት",
    sunday_school_details: "ህጻናት እና ወጣቶች በመንፈሳዊ እውቀት እና በመልካም ስነ ምግባር የሚያድጉበት",
    bible_study: "የመጽሐፍ ቅዱስ ጥናት እና የመንፈሳዊ ትምህርት",
    bible_study_details: "የመጽሐፍ ቅዱስ ጥናት እና የተለያዪ መንፈሳዊ ትምህርቶችን ያገኛሉ",
    community_support: "የማኅበረ ምእመናን ድጋፍ እና ሃአይማኖታዊ በዓላት",
    community_support_details: "ማህበረ ምእመናን አቀፍ ተሳትፎ እና ሃይማኖታዊ ትውፊት ጥብቃ",

    // Service Card Day Labels
    service_day_weekly: "ሳምንታዊ ቅዳሴ",
    service_day_prayer: "ሳምንታዊ ጸሎት",
    service_day_children: "ህፃናት",
    service_day_bible: "መጽሐፍ ቅዱስ ጥናት",
    service_day_community: "ማኅበረ ምእመናን",

    // Timeline labels
    weekly: "ሳምንታዊ",
    sundays: "ሰንበታት",
    saturdays: "ቅዳሜ",
    as_announced: "በማስታወቂያው መሰረት",
    regularly: "በመርህ ግብሩ መሰረት",
    ongoing: "በመካሄድ ላይ",

    // Church Events
    timkat: "ጥምቀት (ኤጲፋንያ)",
    timkat_desc: "የጌታችን ኢየሱስ ክርስቶስ ጥምቀት አከባበር",
    fasika: "ፋሲካ",
    fasika_desc: "የጌታችን እና የመድኃኒታችን የኢየሱስ ክርስቶስ ትንሳኤ አከባበር ",

    // Church Building
    church_building_desc:
      "ለቤተ ክርስቲያን እና ለተለያዩ አገልግሎቶች ሊውሉ የሚችሉ አዳራሾችን መስሪያ የሚሆን ቦታ ገዝተን ህንጓዎችን ለመስራት በዝግጅት ላይ እንገኛለን ",

    // About Our Church - Timeline Section Headers (Amharic)
    timeline_section_1_title: "ቅድመ ቤተ ክርስቲያን",
    timeline_section_2_title: "የቤተክርስቲያኗ መቋቋም",
    timeline_section_3_title: "የወድፊት እቅዶች",

    // Leadership Details
    head_priest_desc: "መልአክ ጽዮን ቆሞስ አባ ተክለ ሥላሴ ቦካን",
    spiritual_coordinator_desc: "ሊቀ ዲያቆን ዳዊት ሻፌ",
    head_priest_email: "Email",
    head_priest_phone: "Phone",
    spiritual_coordinator_email: "Email",
    spiritual_coordinator_phone: "Phone",

    // Address Info
    street_address: "206 Coast Road, Wainuiomata",
    city_name: "Lower Hutt",
    postal_code: "5373",
    country_name: "New Zealand",

    // Bank Details
    bank_name: "ANZ Bank",
    account_name: "ኢትዮጵያዊ ኦርቶዶክስ ቴዋህዶ ቤተክርስቲያን",
    reference_number: "ቤተክርስቲያን ግንባታ ፕሮጀክት",

    // About Our Church - Full Descriptions
    about_church_intro: `
በስመ አብ ወወልድ ወመንፈስ ቅዱስ አሐዱ አምላክ። አሜን። የዌሊንግተን ጽርሐ ጽዮን ቅድስት ማርያም ቤተክርስቲያን አሁን ካልችበት ቦታ ከመድረሷ በፊት በሀገረ ኒውዚላንድ ይኖሩ የነበሩ ኦርቶዶክሳዊያን ምእመናን ቅድስት ኦርቶዶክሳዊት ሃይማኖታቸውን ለመጠበቅና መንፈሳዊ ህይወታቸውን ለማሻሻል በግለሰብ ቤት እና የተለያዩ አዳራሾችን በመከራየት በ2001 እኤአ ማህበር አቋቁመው እርስ በርሳቸው እየተማማሩ፣ በጋራ ይጸልዩ ነበር። በዚህ ማህበራቸውም የቤተክርስቲያን አባት ሳይኖራቸው ወንጌልን እያነበቡና እየተማማሩ፣ ተአምራትን እና ገድላትን እያነበቡ በእመቤታችን ስም ተሰባብስበው የነፍሳቸውን ቃለ እግዚአብሔር ጥማት ያስታግሱ ነበር። በኋላም ክርስትና ሲኖር እና አንዳኣንድ ክብረ በዓላትን ከኦክላንድና ከክራይስት ቸርች ካህን እና ጽላት እየመጣ በአንድ ካህን የቅዳሴ አገልግሎት ተጀመረ። ይህ አገልግሎት በፊት ከነበረው ይልቅ የተሻል ነበር። ነገር ግን ቋሚ አገልጋይ ካህን ስላልነበር ሙሉ አገልግሎት በተፈለገው ጊዜ ማግኘት ስለማይቻል ቋሚ አገልጋይ ካህን ለማስመጣት ጥረት ማድረግ ተጀመረ። በዚህ ሂደት ላይ እንዳለ በሃምሌ 2016 ዓም የጽዋ ማህበሩ በኒው ዚላንድ የበጎ አድራጎት ተቋም ሆኖ የኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቅድስት ማርያም ኢንኮርፖሬትድ በሚል ስም ተመዘገበ። ይህም ማህበሩ ሕጋዊ ሰውነት እንዲኖረውና በመደራጀት የገቢ ማሰባሰቢያ በማድረግ ለአሁኗ ቤተ ክርስቲያን መቋቋም ታላቅ አስተዋጽኦ አድርጓል።

ቋሚ የሆነ አባት እንዲኖረ ከነበረው ጽኑ ፍላጎት የተነሳ ከ 3 ዓመት ድካም እና ውጣ ውረድ በኋላ እግዚአብሄር ፈቃዱ ሆኖ ሕዳር 28 2018 እ ኤ አ አሁን እያገለገሉ ያሉትን አባት መልአከ ጽዮን ቆሞስ አባ ተክለ ስላሴ ሊመጡ ችለዋል። ከ17 ዓመት የማህበር ጉዞ በኋላ በዚሁ ዓመት በመስከረም ወር በወቅቱ የምሥራቅ አውስትራሊያ እና ኒውዚላንድ ሃገረ ስብከት ሊቀ ጳጳስ በነበሩት በብጹእ አቡነ ሄኖክ መልካም ፈቃድ የእመቤታችን የቅድስት ድንግል ማርያም ጽላት ሲመጣ እግዚአብሔር ፈቅዶ ማህበሩ ወደ ቤተክርሲያንነት አደገ። ለብዙ ዘመናት ቀድሶ የሚያቆርብ፣ ምስጢራትን የሚፈጽም፣ ወንጌለ መንግስትን የሚሰብክ፣ ልጆቻቸውን የሚያስተምር ካህን ሲጠሙ ለነበሩት ምእመናን ይህ የቤተ ክርስቲያን መቋቋምና ካህን መምጣት ቋሚ የሆነ መንፈሳዊ አገልግሎት እንዲያገኙ አድርጓቸዋል። አባታችንም ከመጡበት ጊዜ ጀምሮ ደከመኝ ሰለቸኝ ሳይሉ ጌታችንና መድኃኒታችን ኢየሱስ ክርስቶስ ‘‘ግልገሎቼን አሰማራ፣ ጠቦቶቼን ጠብቅ፣ በጎቼን አሰማራ'’ ዮሐ 21፡15-17 ተብሎ የተሰጣቸውን ኃላፊነት በመውሰድ ምእመናንን በመሰብሰብ፣ ቃለ እግዚአብሄርን በመስበክ፣ ምስጢራትን በመፈጸም፣ ሰንበት ተማሪዋችን አደራጅቶ በማስተማር እንዲሁም ቅዳሴ ተሰጥኦ እና ግብረዲቁና በማስተማር ብዙ ዲያቆናትን በማፍራት አገልግሎቱ እንዲሰፋ በማድረግ የእረኝነት ስራቸውን እያከናወኑ ይገኛሉ።། 

በአሁኑ ጊዜ አገልግሎት እየተካሄደ ያለው ቤተ ክርስቲያን በመከራየት ቢሆንም ቤተ ክርስቲያናችን በመስከረም 27፣ 2023 እ ኤ አ 5.2 ሄክታር ስፋት ያለው ውብ የሆነ ቦታ ገዝታ ህንጻ ቤተክርስቲያን ለመገንባት ፈቃድ አግኝታ በመንቀሳቀስ ላይ ትገኛለች። በዚህ ቦታ ላይም ምእመናን የተለያዩ አገልግሎት ሊያገኙ የሚችሉበትን የቤተ ክርስቲያን፣ የክርስትና ቤት፣ የጸበል ቤት፣ አዳራሽና የእንግዳ ማረፊያ ቤት ለመገንባት እቅድ ተይዞ ገንዘብ በማሰባሰብ ላይ እንገኛልን። `,

    about_church_mission:
      "የእኛ ተልእኮ ለማኅበረ ምእመናን ምግበ ነፍስን የሚያገኙበት መንፈሳዊ ቤት መስጠት፣ ሐዋርያዊ እምነትና ትውፊትን መጠበቅ፣ ለማኅበረ ምእመናን ተደራሽ የሆነ የመንፈሳዊ ጥበቃ አገልግሎት መስጠት፣ የማኅበረሰብና ኦርቶዶክሳዊ የባህል ማንነትን ማጎልበት፣ ለተቸገሩት መንፈሳዊ መጠጊያ መሆን ነው።",

    // Ethiopian Calendar & Holidays
    ethiopian_calendar: "የኢትዮጵያዊ ቀን አቆጣጠር ",
    today: "ዛሬ",
    prev_month: "← ቀዳሚ ወር",
    next_month: "ቀጣይ ወር →",
    prev_month_disabled: "ወደ ኋላ ወር መመለስ አይችሉም",
    next_month_disabled: "ወደፊት ከአንድ ዓመት በላይ ማየት አይችሉም",
    current_month_message: "ባሁኑ ወር ላይ ነዎት። ወደ ኋላ ወራት ላይ ማሸጋገር አይችሉም።",
    forward_limit_message: "ወደ ፊት መሸጋገሪያ ወሰን ላይ ደርሰዋል",
    holiday: "ክብረ በዓላት",
    fast_day: "የጾም ቅኖች",
    normal: "ፍስክ ቀኖች",

    // Major Ethiopian Orthodox Holidays
    meskel: "መስቀል",
    meskel_date: "17 መስከረም",
    meskel_gregorian: "መስከረም 27",
    meskel_desc:
      "ንግስት እሌኒ የጌታችንና የመድኃኒታችን የኢየሱስ ክርስቶስ መስቀል ያስግኘችበት ታሪክ የሚከበርበት",

    ganna: "ጌና/ልደት",
    ganna_date: "29/28 ታህሳስ",
    ganna_gregorian: "January 7",
    ganna_desc: "የጌታችንና የመድሃኒታችነ የኢየሱስ ክርስቶስ ልደት",

    timkat: "ጥምቀት (ኤጲፋንያ)",
    timkat_date: "ጥር 11",
    timkat_gregorian: "January 19",
    timkat_desc: "የጌታችንና የመድሃኒታችነ የኢየሱስ ክርስቶስ ጥምቀት",

    fasika: "ትንሣኤ",
    fasika_date: "ተለዋወጭ ቀን",
    fasika_gregorian: "ሚያዝያ/ግቦት",
    fasika_desc: "የጌታችንና የመድሃኒታችነ የኢየሱስ ክርስቶስ ትንሳኤ",

    eriter: "ሰሙነ ህማማት",
    eriter_date: "ከትንሣኤ በፌት ያለው አንድ ሳምንት",
    eriter_gregorian: "ተለዋዋጭ",
    eriter_desc: "ከትንሣኤ በፊት ክርስቶስ ፍቅሩን የገለጸበት ሳምንት",

    dimiter: "ዲሚሌር ወ ምር ዓቢ",
    dimiter_date: "9 ሚያዝያ (May 17)",
    dimiter_gregorian: "May 17",
    dimiter_desc: "ሚካኤል 천사와 სხვა천사들 ልደት",

    assumption: "እርገተ ቅድሥት ድንግል ማርያም",
    assumption_date: "16 ነሐሴ",
    assumption_gregorian: "August 23",
    assumption_desc: "እመቤታችን ቅድስት ድንግል ማርያም እንደልጇ ያረግችበት",

    archangel: "ሊቀ መላእክት ቅዱስ ሚካኤል",
    archangel_date: "12 ሰኞ",
    archangel_gregorian: "November 8",
    archangel_desc: "ዓመታዊ የቅዱስ ሚካእል ክብረ በዓል",

    martyrs: "ቅዱሳን የሂደ ዜና",
    martyrs_date: "29 ሐምሌ (July 8)",
    martyrs_gregorian: "July 8",
    martyrs_desc: "ቅዱሳን የሂደ ዜና ጥምቀት",

    noel: "ኖኤል",
    noel_date: "25 ታህሳስ (January 2 - ጂ/ጂ)",
    noel_gregorian: "January 2",
    noel_desc: "ኢትዮጵያዊ ቅዳሳት ሚያዳ",

    epiphany: "ደምዓት ኢየሱስ ጥምቀት",
    epiphany_date: "11 ታሞዝ (January 19)",
    epiphany_gregorian: "January 19",
    epiphany_desc: "ኢየሱስ ጥምቀት ልደት",

    circumcision: "ሰርዓተ መጠምዓት ኢየሱስ",
    circumcision_date: "13 ታህሳስ (January 1 - ጂ/ጂ)",
    circumcision_gregorian: "January 1",
    circumcision_desc: "ኢየሱስ ሰርዓተ መጠምዓት ልደት",

    nativity_mary: "ሥዕለ-ደምዓት ሶስተ ሪ",
    nativity_mary_date: "30 ወለጁ (September 8)",
    nativity_mary_gregorian: "September 8",
    nativity_mary_desc: "ሶስተ ሪ ሥዕለ-ደምዓት ልደት",

    all_saints: "ሁሉም ቅዱሳን",
    all_saints_date: "1 ኃምሌ (July 20)",
    all_saints_gregorian: "July 20",
    all_saints_desc: "ሁሉም ቅዱሳን ልደት",

    trinity: "ሕትረ-ሥላሴ (ሥላሴ)",
    trinity_date: "ተለዋወጠ ቀን (50 ቀን ከ Fasika በኋላ)",
    trinity_gregorian: "Variable (May/June)",
    trinity_desc: "የሰላሳ-ሥላሴ ልደት ወ ዓመታት",

    // Worship Services Details
    weekly_liturgy_title: "የእለተ ሰንበት ኪዳን እና ቅዳሴ",
    weekly_liturgy_time: "በየሳምንቱ እሁድ ከ5AM-11AM",
    weekly_liturgy_location: "206 Coast Road, Wainuiomata",

    prayer_fellowship_title: "ጽሎትና የትምህርት",
    prayer_fellowship_time: "ከሰኞ እስከ አርብ",
    prayer_fellowship_location: "ቤተክርስቲያን",

    sunday_school_title: "የህፃናት ሰንበት ት/ት",
    sunday_school_time: "በየሳምንቱ ቅዳሜ",
    sunday_school_location: "መማሪያ ክፍሎች",

    bible_study_title: "የመጽሐፍ ቅዱስ ትምህርት እና ሌሎች መንፈሳዊ ትምህርቶች",
    bible_study_time: "በማስታወቂያ ይነገራል",
    bible_study_location: "ቤተክርስቲያን",

    community_support_title: "ማህበራዊ ድጋፍ እና ሃይማኖታዊ ትውፊታዊ በዓላት",
    community_support_time: "በ ካሌንደሩ መሰረት እና እንደ አስፍላጊነቱ",
    community_support_location: "ቤተክርስቲያን እና በአደባባይ",

    // Calendar UI
    calendar_prev_label: "← ዘለፈ",
    calendar_next_label: "ሚቶ →",
    calendar_today_label: "ዛሬ",
    calendar_holiday_label: "ቅዋስ ዓመታት",
    calendar_fast_label: "ውጧ ውለ",
    calendar_normal_label: "ተራ ቀን",

    // Additional Navigation & Contact
    home: "ዋናው ገጽ",
    about: "ስለእኛ",
    leadership: "አስተዳደር",
    gallery: "ጋለሪ",
    donate: "ለግሱ",

    // Form Labels (Contact)
    name_label: "ስም",
    email: "ኢሜይል",
    message: "መልዕክት",
    send: "ላክ",
    required_field: "ያስፈልጋል",

    // General Labels
    date: "ቀን",
    time: "ሰአት",
    location: "ቦታ",
    read_more: "ተጨማሪ ያንብቡ",
    close: "ዝጋ",
    menu: "ዝርዝር",
    search: "ፈልግ",
  },
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || translations.english[key] || key;
};
